import React from "react";

const Content = (props) => {
  const { dataSource } = props;

  return (
    <section className={`nfw-section${dataSource.alt ? " nfw-section-alt" : ""}`}>
      <span className="nfw-anchor" id={dataSource.id} />
      <div className="nfw-wrap">
        <div className="nfw-section-head">
          <div>
            {dataSource.kicker && (
              <p className="nfw-kicker">{dataSource.kicker}</p>
            )}
            <h2 className="nfw-h2">{dataSource.title}</h2>
          </div>
          {dataSource.subtitle && (
            <p className="nfw-lead">{dataSource.subtitle}</p>
          )}
        </div>
        <div className="nfw-mini-cards">
          {dataSource.items.map((item) => {
            const body = (
              <div className="nfw-mini nfw-glass">
                {item.tag && <span className="nfw-tag">{item.tag}</span>}
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            );
            return item.href ? (
              <a href={item.href} key={item.title}>
                {body}
              </a>
            ) : (
              <div key={item.title}>{body}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Content;
